import { API } from "aws-amplify";

export class ChangelogApi {
  static async getHistory(body: any) {
    return await API.get("changelog", `/${body.hotelId}/${body.dayDate}`, {});
  }
}
